(() => {
  const $document = $(document);

  $document.off("click.retail_store_display");

  $document.on("click.retail_store_display", ".retail_store_display", function () {
    $(".retail_store_popup").addClass("is-open");
  })
  $document.on("click.retail_store_display", ".retail_store_popup .close_btn", function () {
    $(".retail_store_popup").removeClass("is-open");
  })
  $document.on("click.retail_store_display", ".retail_store_popup", function (e) {
    if (e.target === this) {
      $(".retail_store_popup").removeClass("is-open");
    }
  })
})();
